<div *ngIf='componentReady' class='PrecessUpload py-3'>
  <div class='ProcessUpload-header'>
    <h4>Upload Contacts</h4>
  </div>
  <div class='ProcessUpload-form container'>
    <div *ngIf='importError' class='alert alert-danger'>
      <p>{{ importError }}</p>
    </div>
    <form [formGroup]='formGroup'>
      <div class='ProcessUpload-group_select'>
        <div class='ProcessUpload-form-header'>
          <h4>User Contact Group</h4>
        </div>
        <div class='row'>
          <div class='col col-md-12'>
            <mat-form-field>
              <mat-label>Select Existing group</mat-label>
              <mat-select
                (selectionChange)='onGroupSelection($event)'
                formControlName='group_id'>
                <mat-option
                  *ngFor='let item of contactGroupsItems'
                  [value]='item.value'>
                  {{ item.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf='showGroupControl' class='row'>
          <div class='col col-md-12'>
            <mat-form-field>
              <mat-label>Group name:</mat-label>
              <input
                (focusout)='checkNewGroup($event.target.value)'
                formControlName='group_name'
                matInput
                name='group_name' />
            </mat-form-field>
            <div
              *ngIf='
                group_name.touched && !group_name.valid && group_name.errors
              '
              class='alert alert-danger'>
              <p *ngIf='group_name.errors.required'>Group name is required!</p>
            </div>
          </div>
        </div>
        <div class='row mb-3'>
          <div class='col col-12 col-sm-6'>
            <mat-checkbox
              formControlName='keep_group'
            >Keep current group if contacts from your uploaded file already exists
            </mat-checkbox>
          </div>
        </div>
      </div>
      <div class='ProcessUpload-fields_map'>
        <div class='ProcessUpload-form-header'>
          <h4>Set fields mapping</h4>
        </div>
        <div *ngFor='let row of firstRowKeys' class='row'>
          <div class='col col-12 col-md-4'>
            <p>{{ row }}</p>
          </div>
          <div class='col col-12 col-md-4'>
            <p>{{ firstRow[row] }}</p>
          </div>
          <div class='col col-12 col-md-4'>
            <mat-form-field>
              <mat-label>Map to...</mat-label>
              <mat-select formControlName='{{ row }}'>
                <mat-option
                  *ngFor='let item of fieldMaps[row]'
                  [value]='item.value'>
                  {{ item.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class='ProcessUpload-preview'>
        <div class='ProcessUpload-form-header'>
          <h4>Preview</h4>
        </div>
        <div *ngIf='tableReady' class='ProcessUpload-preview-container'>
          <app-table [columns]='tableColumns' [dataSourceParams]='tableDatasourceParams'
                     [dataSource]='tableDataSource'></app-table>
        </div>

        <!--
                <div class="ProcessUpload-form-row ProcessUpload-form-row-header row">
                    <div *ngFor="let key of firstRowKeys" class="col col-12 col-md-{{getCellNumber()}}">
                        <span>{{mapping[formGroup.get(key).value]}}</span>
                    </div>
                </div>
                <div *ngFor="let item of samples" class="row ProcessUpload-form-row">
                    <div *ngFor="let sampleKey of getSampleKeys(item)" class="col col-12 col-md-{{getCellNumber()}}">
                        <span>{{item[sampleKey]}}</span>
                    </div>
                </div>
                -->
      </div>
    </form>
  </div>
  <div class='ProcessUpload-footer'>
    <app-button
      [Click]='cancelButtonProperteis.onClick'
      [color]='cancelButtonProperteis.color'
      [size]='cancelButtonProperteis.size'
      [text]='cancelButtonProperteis.text'></app-button>
    <app-button
      [Click]='submitButtonProperties.onClick'
      [color]='submitButtonProperties.color'
      [size]='submitButtonProperties.size'
      [text]='submitButtonProperties.text'></app-button>
  </div>
</div>
<mat-card
  *ngIf='!componentReady'
  style='display: flex; justify-content: center; align-items: center'>
  <mat-progress-spinner color='primary' mode='indeterminate'>
  </mat-progress-spinner>
</mat-card>
